module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_diamonds-10.9f093e52.svg";